import DOMPurify from "dompurify";

export default function parseWhatsAppText(input) {
    if (!input) return "";

    let text = input;

    // Escape HTML first (important for security)
    text = text
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");

    // Handle code blocks (```code```)
    text = text.replace(
        /```([\s\S]*?)```/g,
        (_, code) => `<pre><code>${code}</code></pre>`
    );

    // Handle inline code (`code`)
    text = text.replace(
        /`([^`\n]+)`/g,
        "<code>$1</code>"
    );

    // Bold (*text*)
    text = text.replace(
        /\*(?!\s)([^*]+?)(?<!\s)\*/g,
        "<strong>$1</strong>"
    );

    // Italic (_text_)
    text = text.replace(
        /_(?!\s)([^_]+?)(?<!\s)_/g,
        "<em>$1</em>"
    );

    // Strikethrough (~text~)
    text = text.replace(
        /~(?!\s)([^~]+?)(?<!\s)~/g,
        "<del>$1</del>"
    );

    // Line breaks
    text = text.replace(/\n/g, "<br />");

    return DOMPurify.sanitize(text);
}
